export default __webpack_public_path__ + "static/media/c_plus_plus.2441702d.svg";